/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Knp_Lookup_Create_OneInputs */



/**
* | output |
* | --- |
* | "Create one" |
*
* @param {Knp_Lookup_Create_OneInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const knp_lookup_create_one = /** @type {((inputs?: Knp_Lookup_Create_OneInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Knp_Lookup_Create_OneInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("En creer un")
	if (locale === "de") return /** @type {LocalizedString} */ ("Erstelle einen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Creane uno")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Создайте один")
	if (locale === "es") return /** @type {LocalizedString} */ ("Crea uno")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("创建一个")
	if (locale === "ja") return /** @type {LocalizedString} */ ("作成する")
	if (locale === "hi") return /** @type {LocalizedString} */ ("एक तैयार करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Crie um")
	return /** @type {LocalizedString} */ ("Create one")
});